import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ReturnRequestDto, UpdateLineItemDto } from "../generated/schema";

interface UseUpdateLineItemParams {
  onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useUpdateLineItem(params: UseUpdateLineItemParams) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const mutation = $api.useMutation(
    "patch",
    "/shops/{shopId}/return-requests/{returnRequestId}/line-items/{lineItemId}",
  );

  return useMutation({
    onSuccess(returnRequest) {
      successNotification();
      params.onSuccess(returnRequest);
    },
    onError() {
      errorNotification();
    },
    mutationFn: async (
      data: {
        shopId: string;
        returnRequestId: string;
        lineItemId: string;
      } & UpdateLineItemDto,
    ) => {
      return mutation.mutateAsync({
        params: {
          path: {
            shopId: data.shopId,
            returnRequestId: data.returnRequestId,
            lineItemId: data.lineItemId,
          },
        },
        body: {
          countryOfOrigin: data.countryOfOrigin,
          harmonizedSystemCode: data.harmonizedSystemCode,
          new_variant: data.new_variant,
          resolution: data.resolution as any,
        },
      });
    },
  });
}
